import { useEffect, useState } from 'react';
import { certState, checkCertGlobally } from '../../index';

export const useCheckCert = () => {
  const [isCertFound, setIsCertFound] = useState(() => ({mc: false, harica: false}));

  useEffect(() => {
    // Проверяем, что мы в браузере
    if (typeof window === 'undefined') return;

    // Если глобальное состояние уже установлено — используем его
    if (certState.isChecked && certState.isCertFound) {
      setIsCertFound(certState.isCertFound);
      return;
    }

    // Выполняем глобальную проверку
    checkCertGlobally().then((result) => {
      setIsCertFound(result);
    });
  }, []);

  return { isCertFound };
};
